module.exports = __webpack_public_path__ + "static/media/MongoDB.7b5f1d6d.png";